import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('site-drawer', Component);

    const instances = ref([]);
    const activeInstance = ref(null);

    const disableScroll = () => {
      const body = document.getElementsByTagName('body')[0];

      const scrollbarWidth = window.innerWidth - document.documentElement.getBoundingClientRect().width;

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }

      body.style.overflow = "hidden";
    }

    const enableScroll = () => {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = null;
      body.style.paddingRight = null;
    }

    const getInstance = reference => {
      return instances.value.find(item => item.reference === reference);
    }

    const openInstance = reference => {
      const instance = getInstance(reference);
      instance.open();
      disableScroll();
      activeInstance.value = reference;
    }

    const closeInstance = reference => {
      const instance = getInstance(reference);
      instance.close();
      enableScroll();
      activeInstance.value = null;
    }

    const toggleInstance = reference => {
      if (activeInstance.value === reference) {
        closeInstance(reference);
      } else {
        openInstance(reference);
      }
    }

    const siteDrawer = { instances, activeInstance, openInstance, closeInstance, toggleInstance };
    app.config.globalProperties.$siteDrawer = siteDrawer;
    app.provide('$siteDrawer', siteDrawer);
  }
}